<template>
  <v-dialog
    v-if="session"
    v-model="dialog"
    width="500"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title class="third white--text font-weight-bold">
        <v-icon size="24" color="white">mdi-calendar-plus</v-icon>
        <span class="ml-2">{{ session.name }} - {{ sessionType }}  </span>
        <v-spacer />
        <v-icon size="28" color="white" class="justify-end" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-4">
        <h3 class="black--text">
          Voulez-vous affecter cette ressource à ?
        </h3>

        <RadioGroup
          v-model="option"
          :rules="mandatoryRule"
          :options="dragAndDropOptions"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <Button
          label="Appliquer"
          :action="addResourceToSession"
          icon="mdi-plus"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import { EventBus, mandatoryRule, dragAndDropOptions } from '../../helpers/utils';
import { prepareSession } from '../../helpers/amplify';
import Button from '../common/Button.vue';
import RadioGroup from '../common/RadioGroup.vue';

import store from '@/store';

export default {
  components: { Button, RadioGroup },
  setup () {
    const dialog = ref(false);
    const sessions = computed(() => store.getters.dailySessions);
    const session = ref(null);
    const option = ref('ALL');
    const contentDetailsObject = ref(null);

    const closeDialog = () => {
      dialog.value = false;
    };

    EventBus.$on('showDragAndDropModal', receivedObject => {
      dialog.value = true;
      session.value = receivedObject.session;
      contentDetailsObject.value = receivedObject;
      option.value = 'ALL';
    });

    watch(sessions, () => {
      if (session.value) {
        const sess = sessions.value.find(s => s.uuid === session.value.uuid);
        if (!sess) {
          closeDialog();
          return;
        }

        session.value = { ...sess };
      }
    });

    const sessionType = computed(() => store.getters.referenceValue('equestrian_session_values', session.value.type));

    const addResourceToSession = () => {
      // contentDetailsObject.value.uuid, session.value, contentDetailsObject.value.values, contentDetailsObject.value.type, contentDetailsObject.value.isMultipleValue, option.value
      const params = {
        ...contentDetailsObject.value,
        session: session.value
      };
      prepareSession(params, option.value);
      closeDialog();
    };

    return { dialog, closeDialog, session, sessionType, option, dragAndDropOptions, mandatoryRule, addResourceToSession };
  }

};
</script>
